import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { format, isValid } from 'date-fns';
import config from '../../../config';

const ProductionNew = ({ selectedDate}) => {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null); // 에러 상태 추가
  const [loading, setLoading] = useState(false); // 로컬 로딩 상태

  const dateObj = new Date(selectedDate);
  const formattedDate = isValid(dateObj) ? format(dateObj, 'yyyyMMdd') : null;

  useEffect(() => {
    const fetchData = async () => {
      if (!formattedDate) return;

      setLoading(true); // 로딩 시작

      try {
        const response = await axios.post(
          `${config.apiUrl}/prdtSel.do`,
          { stdate: formattedDate },
          { headers: { 'Content-Type': 'application/json' } },
        );

        const apiData = response.data;
        const transformedData = transformData(apiData);
        setData(transformedData);
        setError(null); // 에러 초기화
      } catch (err) {
        console.error('데이터를 가져오는 중 에러 발생:', err);
        setError('데이터를 가져오는 중 문제가 발생했습니다.'); // 에러 상태 업데이트
      } finally {
        setLoading(false); // 로딩 종료
      }
    };

    fetchData();
  }, [formattedDate, setLoading]);

  const formatNumber = num => {
    if (typeof num === 'number') {
      return num.toLocaleString();
    }
    return num;
  };

  const transformData = apiData => {
    const categories = ['일목표량', '실생산량', '과부족', '이론생산량', '제품율(%)', '월누계', '월목표'];
    const categoryKeys = ['DAY_GOALS', 'DAY_PRQUNT', 'LACKQT', 'THRPRD', 'PRDRAT', 'MON_PRQUNT', 'MON_GOALS'];

    const machines = {
      PM2: { machin: 'PM2', data: {} },
      PM3: { machin: 'PM3', data: {} },
      합계: { machin: '합계', data: {} },
    };

    if (apiData && Array.isArray(apiData.resultData)) {
      apiData.resultData.forEach(entry => {
        const machineKey = entry.HOGIXX === '2호기(KG)' ? 'PM2' : entry.HOGIXX === '3호기(KG)' ? 'PM3' : '합계';

        categoryKeys.forEach((categoryKey, index) => {
          const category = categories[index];

          if (!machines[machineKey].data[category]) {
            machines[machineKey].data[category] = {
              category,
              PM2: '',
              PM3: '',
              합계: '',
            };
          }

          machines[machineKey].data[category] = {
            category,
            PM2: machineKey === 'PM2' ? formatNumber(entry[categoryKey]) : machines[machineKey].data[category].PM2,
            PM3: machineKey === 'PM3' ? formatNumber(entry[categoryKey]) : machines[machineKey].data[category].PM3,
            합계: machineKey === '합계' ? formatNumber(entry[categoryKey]) : machines[machineKey].data[category].합계,
          };
        });
      });

      return [machines.PM2, machines.PM3, machines.합계];
    } else {
      return [machines.PM2, machines.PM3, machines.합계];
    }
  };

  const categories = ['일목표량', '실생산량', '과부족', '이론생산량', '제품율(%)', '월누계', '월목표'];

  const dataWithEmptyRows = categories.map(category => {
    const pm2Data = data[0]?.data[category] || {};
    const pm3Data = data[1]?.data[category] || {};
    const totalData = data[2]?.data[category] || {};

    return {
      category,
      PM2: pm2Data.PM2 || '',
      PM3: pm3Data.PM3 || '',
      합계: totalData.합계 || '',
    };
  });

  // 로딩 중 또는 에러 발생 시의 UI
  if (error) return <div className='text-red-500'>Error: {error}</div>;
 

  return (
    <div className='relative'>
      {loading && (
      <div className='absolute inset-0 bg-black bg-opacity-50 flex justify-center items-center z-10'>
        <div className="text-white text-2xl font-bold">Loading...</div>
      </div>
      )}
      <div className='w-[25%] change_2h page_center bg-blue-200 font-bold text-blue-600'>생산량(Ton)</div>
      <div className='b2-box'>
        <div className='flex flex-row change_2h b2-b'>
          <div className='w-[25%] b2-r h-[100%] page_center text-right'>구분</div>
          <div className='w-[25%] b2-r h-[100%] page_center text-right'>PM2</div>
          <div className='w-[25%] b2-r h-[100%] page_center text-right'>PM3</div>
          <div className='w-[25%] h-[100%] page_center text-right'>합계</div>
        </div>
        {dataWithEmptyRows.map((row, index) => (
          <div key={index} className={`flex flex-row change_2h ${row.category === '월목표' ? '' : 'b-g'}`}>
            <div className='w-[25%] b2-r h-[100%] page_center'>{row.category || '데이터 없음'}</div>
            <div className='w-[25%] b2-r h-[100%] rp-center overflow-hidden text-ellipsis whitespace-nowrap'>
              {row.PM2 || ''}
            </div>
            <div className='w-[25%] b2-r h-[100%] rp-center overflow-hidden text-ellipsis whitespace-nowrap'>
              {row.PM3 || ''}
            </div>
            <div className='w-[25%] b2-rw h-[100%] rp-center overflow-hidden text-ellipsis whitespace-nowrap'>
              {row.합계 || ''}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductionNew;
